import styled from 'styled-components';

const isLocalEnv = process.env.NODE_ENV === 'development';

export const ResetSitecoreStyles = isLocalEnv
  ? styled.div``
  : styled.div`
      word-break: normal;
      width: 100%;

      div[data-whatinput='keyboard'] {
        outline: none;
        :focus {
          outline: none;
        }
      }

      div[role='button'] {
        outline: none;
      }

      div[role='option'] {
        outline: none;
      }

      div[role='option'] {
        outline: none;
        :focus {
          outline: none;
        }
      }

      li[role='listbox'] {
        :hover {
          outline: none;
        }
      }

      ul[role='option'] {
        :hover {
          outline: none;
        }
      }

      label {
        font-size: inherit;
        line-height: inherit;
      }

      input:disabled {
        background-color: transparent;
      }

      a {
        text-decoration: underline;
      }

      input[type='text'] {
        outline: none;
        border: none;
      }

      input[type='radio'],
      input[type='checkbox'] {
        opacity: 1;
        width: 100%;
        height: 100%;
      }

      div[role='presentation'] {
        outline: none;

        :focus {
          outline: none;
        }
      }

      a[role='button'] {
        text-decoration: none;
      }
      svg {
        fill: none;
      }
    `;
